var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22.2446C17.5228 22.2446 22 17.7675 22 12.2446C22 6.72178 17.5228 2.24463 12 2.24463C6.47715 2.24463 2 6.72178 2 12.2446C2 17.7675 6.47715 22.2446 12 22.2446Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.17456C9.93 7.17456 8.25 8.85456 8.25 10.9246C8.25 12.9546 9.84 14.6046 11.95 14.6646C11.98 14.6646 12.02 14.6646 12.04 14.6646C12.06 14.6646 12.09 14.6646 12.11 14.6646C12.12 14.6646 12.13 14.6646 12.13 14.6646C14.15 14.5946 15.74 12.9546 15.75 10.9246C15.75 8.85456 14.07 7.17456 12 7.17456Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.78 19.5946C17 21.2346 14.62 22.2446 12 22.2446C9.37997 22.2446 6.99997 21.2346 5.21997 19.5946C5.45997 18.6846 6.10997 17.8546 7.05997 17.2146C9.78997 15.3946 14.23 15.3946 16.94 17.2146C17.9 17.8546 18.54 18.6846 18.78 19.5946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.ebd74f524085f00917840f04e0121c08.svg";
export { ForwardRef as ReactComponent };